import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { GetPostApiParam, MedicationRequestNew } from '../models/intake/intakeMedication';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
const username = "RxEpServices";
const password = "b3oVyTw7Dhkfas3GxFI6npfWXs0DL8oN2C5WWgcEz/M=";
const applicationName = "string";
@Injectable({
  providedIn: 'root'
})
export class IntakeMedicationService {
  modelDiagonsis: GetPostApiParam = new GetPostApiParam();
  progress$: any;
  private progressObserver: any;
  private progress: any;
  MedicationRequest: MedicationRequestNew =new MedicationRequestNew();

  constructor(private genericService: GenericUtilityService, public _httpClient: HttpClient) {
    this.progress$ = Observable.create((observer: any) => {
      this.progressObserver = observer
    })
  }

 
  private handleError(error: any) {
    // Handle the error here
    console.error('An error occurred:', error);
    return throwError(error);
  }
  GetTokenForMedication() {
    console.log("inside medication");
    this.MedicationRequest.UserName = username;
    this.MedicationRequest.Password = password;
    this.MedicationRequest.ApplicationName = applicationName;
   // console.log(this.MedicationRequest);

    return this._httpClient.post("https://live-webservices.mtbc.com/Talklive/api/Authentication/GetToken", this.MedicationRequest)
      .pipe(
        catchError(this.handleError)
      )
      //.subscribe(response => {
      //  console.log("API response:", response);
      //  localStorage.setItem("data", response)
      //}, error => {
      //  console.error("API error:", error);
      //});
  }
  apiUrl: any = 'https://live-webservices.mtbc.com/Talklive/api/Medication/GetMedicineByName';
  GetPatientMedicationFromFD(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + localStorage.getItem("medToken"),
      //'Custom-Header': 'CustomValue'
    });

    return this._httpClient.post(this.apiUrl, data, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  apiUrlSig: any = 'https://live-webservices.mtbc.com/Talklive/api/Medication/DynamicSig';

  GetDynamicSig(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': "Bearer " + localStorage.getItem("medToken"),
    });

    return this._httpClient.post(this.apiUrlSig, data, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

 

  GetPatientMedications(practiceCode: any, patientAccount: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetPatientMedications_v2?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount);
  }
  DeletePatientMedication(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeleteMedicine_V2", data);
  }
  SavePatientMedications(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveMedicine_v1", data);
  }
  SavePatientMedicationsPhoto(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveMedicine_Photo", data);
  }
  SavePatientMedicationsPhotoToEHR(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveMedicine_Photo_EHR", data);
  }
  uploadAtFolder(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {

    return this.makeFileRequest(files, folder, PATIENT_ACCOUNT, PRACTICE_CODE);
  }
  private makeFileRequest(files: File, folder: any, PATIENT_ACCOUNT: any, PRACTICE_CODE: any): Observable<any> {
    return Observable.create((observer: any) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
        this.progress = Math.round(event.loaded / event.total * 100);
        if (this.progressObserver)
          this.progressObserver.next(this.progress);
      };
      xhr.open('POST', this.genericService.getBaseIpTalkPhr() + folder, true);
      // for (let i = 0; i < files.length; i++) {
      formData.append("PatientAccount", PATIENT_ACCOUNT);
      formData.append("PracticeCode", PRACTICE_CODE);
      formData.append("image", files);
      //formData.append("uploads", files[i].name);
      //formData.append("size", files[i], files[i].size.toString());
      //formData.append("type", files[i], files[i].type);
      // }
      //add JWT token for save profile pic
      xhr.setRequestHeader('Authorization', "Bearer " + localStorage.getItem("AuthTokenwebServices"));
      xhr.send(formData);
    });
  }
  GetSolarApiDiagonsis(data: string, patientAccount: any, practiceCode: any) {

    if (data != null) {

      this.modelDiagonsis.PatientAccount = patientAccount;
      this.modelDiagonsis.PracticeCode = practiceCode;
      this.modelDiagonsis.PaginationSize = '20';
      this.modelDiagonsis.EndTo = '19';
      this.modelDiagonsis.Query = data;
      return this.genericService.GenericExternalServiceCallerPost("https://smartsearch.mtbc.com/api/talkEHRICDsTenNineSnomedForDoctors/PickICDsTenNineSnomedForDoctors", this.modelDiagonsis);
    }
  }
  GetSolarApiMedications(data: string) {
    return this.genericService.GenericExternalServiceCallerGet("https://smartsearch.mtbc.com/api/TalkPHRMedicine/BlockChainMedicinesTalkPHR?Query=" + data);
  }
}
